module.exports = __webpack_public_path__ + "img/banner_h5.e1c6eb2b.jpg";